import { Pumpe } from "./productfinder-result";
import { ProductfinderData } from "./productfinder-data";

export class ProductfinderCustomerData {
  constructor(other?: ProductfinderCustomerData) {
    if (other) $.extend(true, this, other);
  }

  salutation: number;
  name: string;
  email: string;
  company: string;
  address: string;
  industry: string;
  quantity: number;
  mountingParts: string;
  motor: string;
  atex: string;
  abnahmen: string;
  datenschutz: boolean = false;

  /**
   * Returns a clone of this instance, which can be used to send it to the
   * server.
   */
  createCopyForServer(): ProductfinderCustomerData {
    // clone this, see http://stackoverflow.com/a/122704/1601438
    let clone = $.extend(true, {}, this);
    // cleanup typescript metadata
    delete clone["__metadata__"];
    delete (clone as any)["createCopyForServer"];
    return clone;
  }
}

export class ProductfinderOfferData {
  constructor(
    customerData: ProductfinderCustomerData,
    inputData: ProductfinderData,
    pumpen: Pumpe[],
  ) {
    this.customerData = customerData;
    this.inputData = inputData;
    this.pumpen = pumpen;
  }

  customerData: ProductfinderCustomerData;
  inputData: ProductfinderData;
  pumpen: Pumpe[];
}

export class ProductfinderOfferResult {}
